<template>
    <admin-layout class="tenants">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1>Professional Development</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Connect with experts and perfect your craft.</li>
                        </ol>
                    </nav>
                </div>
            </template>

            <hr class="my-0">

            <section class="px-4 py-3">
                <div class="course-list">
                    <div class="row">
                        <template v-for="(course, index) in courses">
                            <div class="col-md-6 col-xl-4">
                                <course-card :course="course"
                                              class="mb-4"/>
                            </div>
                        </template>
                    </div>
                </div>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
import CourseCard from "@/Components/Course/CourseCard";
import API from "@/API";
import utils from "@/mixins/utils";

export default {
    name: "EmbedPDPaid",
    components: {
        CourseCard,
        AdminLayout, 
        AppContentPane},

    mixins: [utils],

    props: ['oauth_url'],

    data(){
        return{
            courses: [],
        }
    },

    computed: {
    },

    methods: {
        async fetchCourses(){
            this.courses = await API.courses.bulk();
        },        
    },

    beforeMount() {
        
    },    

    created() {
        this.fetchCourses();
    },

    mounted() {
        this.setTitle("Professional Development");
    }

}
</script>
<style lang="scss" scoped>
.embed{
    font-size: 0;
}
</style>
